import LeaveRequestTypeList from "./pages/ListPage.vue";
import LeaveRequestTypeDetail from "./pages/FormPage.vue";
import LeaveRequestTypeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/leave_request_type",
    component: LeaveRequestTypeIndex,
    redirect: "/leave_request_type/list",
    name: "leave_request_type",
    children: [
      {
        path: "list",
        component: LeaveRequestTypeList,
        name: "leave_request_type.list",
      },
      {
        path: "create",
        component: LeaveRequestTypeDetail,
        name: "leave_request_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: LeaveRequestTypeDetail,
        name: "leave_request_type.edit",
        props: { create: false },
      },
    ],
  },
];
